import { useEffect, useState } from "react";
import { ApiError, api } from "../../data";
import { PillView } from "../../components/ui";
import type { Pill } from "../../model/invoice-view";

/**
 * Zustände innerhalb des Rahmens der Betreiber-Konsole (main.auth-shell). Die gemeinsamen Zustände (components/States)
 * bringen ein eigenes <main> mit und passen deshalb nicht in diesen Rahmen; Texte nach der Zustandsbibliothek.
 */

export function Laden({ label = "Wird geladen …" }: { label?: string }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 300);
    return () => clearTimeout(t);
  }, []);
  return <p className="muted tk-loading" aria-busy="true">{show ? label : ""}</p>;
}

export function isForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.forbidden;
}

export function KeinZugriff() {
  return (
    <div className="panel stack tk-empty" role="alert">
      <h2>Diese Seite ist nicht freigegeben.</h2>
      <p>Nur für den Plattform-Betrieb. Die Datenbank hat den Zugriff für dieses Konto abgelehnt.</p>
    </div>
  );
}

export function Fehler({ error, retry }: { error: unknown; retry?: () => void }) {
  if (isForbidden(error)) return <KeinZugriff />;
  const message = error instanceof Error ? error.message : String(error);
  const network = /fetch|network|Failed to/i.test(message);
  return (
    <div className="panel stack tk-empty" role="alert">
      <h2>{network ? "Verbindung fehlgeschlagen." : "Laden nicht möglich."}</h2>
      <p>{network ? "Bitte erneut versuchen." : message}</p>
      {retry && <div className="row"><button className="" onClick={retry}>Erneut versuchen</button></div>}
    </div>
  );
}

export function DemoHinweis() {
  return api.mode === "demo" ? <p className="demo-note">Demo · Alle Daten sind erfunden.</p> : null;
}

/** Balken aus dem Paket (.progress) mit Wert für Vorleseprogramme. */
export function Fortschritt({ pct, label }: { pct: number; label: string }) {
  const value = Math.round(Math.max(0, Math.min(100, pct)));
  return (
    <div className="progress" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={value}>
      <span style={{ width: `${value}%` }} />
    </div>
  );
}

export function MaybePill({ pill }: { pill: Pill | null }) {
  return pill ? <PillView pill={pill} /> : null;
}
